import {$, $$} from "functions/dom";
import {toggleMeilisearchSearchModal} from "functions/helper";

export function initDropdown() {

    // Filter Drop
    let filterDrop = $(".dropdown .default_option");
    if (filterDrop !== null && filterDrop !== undefined) {
        filterDrop.addEventListener("click", () => {
            let filterElm = document.querySelector(".dropdown .default_option + ul");
            filterElm.classList.toggle("active");
        });
    }

    // Table DropDown
    let dropdownList = $$(".dropdownList .default_option");
    dropdownList.forEach((dropdown) => {
        let dropdownListElm = dropdown.parentElement.querySelector("ul");
        if (dropdownList !== null && dropdownList !== undefined) {
            dropdown.addEventListener("click", () => {
                dropdownListElm.classList.toggle("active");
            });
        }
    })


    /**
     * Menu Toogle
     * @type {Element}
     */
    let toogle_menu = document.querySelector("#toogle_menu")
    let navs_links = document.querySelector(".navs_links")
    toogle_menu?.addEventListener('click', (e) => {
        toogle_menu.classList.toggle("active")
        navs_links.classList.toggle("show_menu")
    })

    /**
     * Search Moal
     * @type {Element}
     */
    let searchModalButton = document.querySelector("#searchModalButton")
    searchModalButton?.addEventListener('click', (e) => {
        toggleMeilisearchSearchModal()
    })
}

/**
 * Table DropDown Action menu
 * @param parentElement
 */
export function tableDropdownAction(parentElement = null) {
    let prefix_element = parentElement ? parentElement + " " : ""
    let table_drop_action = $$(prefix_element + '.table_drop_action');
    table_drop_action.forEach(element => {
        element.addEventListener("click", () => {
            table_drop_action.forEach(elm => {
                if (elm.classList.contains("active") && elm !== element) {
                    elm.classList.remove("active");
                }
            });
            element.classList.toggle("active");
        });
    });
}
